// @need-translate
import {decode} from 'he';
import {getAgeGradeText} from '../../../common/getAgeGradeText';
import {t} from '../../../common/getTranslations';
import {ApiStatusCodeVo} from '../../../common/shared/api/nicolas/vo/enums/ApiStatusCodeVo.enum';
import {
  AgeGrade,
  Maybe,
  RedeemCodeType,
} from '../../../graphql/generated/types';
import {Dialog} from '../type';

export interface GetDialogProps {
  type: RedeemCodeType;
  title?: string;
  ageGrade?: Maybe<AgeGrade>;
  resultCode?: ApiStatusCodeVo;
}

export function getDialog({
  type,
  title = '',
  ageGrade,
  resultCode,
}: GetDialogProps): Dialog {
  if (type === RedeemCodeType.Credit) {
    return {
      title: t('more_coupon_register_complete_button'),
      description: t('more_coupon_register_cash_charge_success_popup'),
      activeButton: t('more_coupon_register_goto_charge_history_button'),
      secondButton: t('common_confirm_button'),
    };
  } else if (type === RedeemCodeType.Ticket) {
    return {
      title: t('more_coupon_register_complete_button'),
      description: t('more_coupon_register_ticket_charge_success_popup', {
        values: {
          value: decode(title),
        },
      }),
      activeButton: t('viewer_end_contenthome_button'),
      secondButton: t('common_confirm_button'),
    };
  } else if (
    type === RedeemCodeType.TicketBuy ||
    type === RedeemCodeType.TicketRent
  ) {
    return {
      title: t('more_coupon_register_complete_button'),
      description: t(
        'more_coupon_register_ticket_charge_success_popup_goto_home',
        {
          values: {
            value: decode(title),
            ticket:
              type === RedeemCodeType.TicketRent
                ? t('common_ticket_rental')
                : t('common_ticket_possession'),
          },
        }
      ),
      activeButton: t('viewer_end_contenthome_button'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.ExternalNotAuthorized) {
    return {
      title: t('more_coupon_register_certification_popup'),
      activeButton: '본인인증하기',
    };
  } else if (resultCode === ApiStatusCodeVo.RedeemInvalidForm) {
    // 코드가 잘못됐을 경우. 메타 정보가 없을때.
    return {
      title: t('api_reward_redeem_invalid_form'),
      secondButton: t('common_confirm_button'),
    };
  } else if (
    resultCode === ApiStatusCodeVo.RedeemAlreadyUsed ||
    resultCode === ApiStatusCodeVo.RedeemPreparedQuantityExhausted
  ) {
    // 사용횟수 검사. 폐기시킨 코드.
    return {
      title: t('api_reward_redeem_already_used'),
      secondButton: t('common_confirm_button'),
    };
  } else if (
    resultCode === ApiStatusCodeVo.RedeemExpiredCoupon ||
    resultCode === ApiStatusCodeVo.ExternalExpiredCoupon
  ) {
    // 사용기간 만료
    return {
      title: t('api_reward_redeem_expired_coupon'),
      secondButton: t('common_confirm_button'),
    };
  } else if (
    resultCode === ApiStatusCodeVo.RedeemAlreadyReceived ||
    resultCode === ApiStatusCodeVo.ExternalUsedCoupon ||
    resultCode === ApiStatusCodeVo.RedeemDuplicatedRedeemCodeHistoryOperation
  ) {
    // 동일한 코드를 사용했을 경우
    return {
      title: t('api_reward_redeem_already_received'),
      secondButton: t('common_confirm_button'),
    };
  } else if (
    resultCode === ApiStatusCodeVo.RedeemAlreadyUsedCodeGroup ||
    resultCode === ApiStatusCodeVo.RedeemCannotUseInSameCampaign
  ) {
    // 코드 그룹을 이미 사용했음
    return {
      title: t('api_reward_redeem_same_event_already_used'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.RedeemTooShortRequest) {
    // 연속해서 두번 이상 요청하는 등 이미 이전 코드를 처리하고 있을 때
    return {
      title: t('api_reward_redeem_too_short_request'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.RedeemOnlyNewlyJoinedUser) {
    return {
      title: t('api_reward_redeem_only_new_user'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.RedeemOnlyReturnUser) {
    return {
      title: t('api_reward_redeem_only_return_user'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.RedeemOnlyNewlyJoinedUserAfter) {
    return {
      title: t('api_reward_redeem_only_new_user_after'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.RedeemOnlyNewlyJoinedUserBefore) {
    return {
      title: t('api_reward_redeem_only_new_user_before'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.RedeemProductNotOnSale) {
    return {
      title: t('api_reward_redeem_product_not_sales'),
      secondButton: t('common_confirm_button'),
    };
  } else if (
    resultCode === ApiStatusCodeVo.RedeemInvalidCoupon ||
    resultCode === ApiStatusCodeVo.ExternalAbnormalCoupon ||
    resultCode === ApiStatusCodeVo.ExternalNotExistCoupon ||
    resultCode === ApiStatusCodeVo.RedeemInvalidCodeGroup
  ) {
    return {
      title: t('api_reward_redeem_invalid_coupon'),
      secondButton: t('common_confirm_button'),
    };
  } else if (
    resultCode === ApiStatusCodeVo.RedeemUseFail ||
    resultCode === ApiStatusCodeVo.ExternalNeedParameter ||
    resultCode === ApiStatusCodeVo.ExternalInvalidDataForm ||
    resultCode === ApiStatusCodeVo.ExternalNeedBrandCode ||
    resultCode === ApiStatusCodeVo.ExternalMismatchProduct ||
    resultCode === ApiStatusCodeVo.ExternalMismatchCode ||
    resultCode === ApiStatusCodeVo.ExternalRequestHeaderError ||
    resultCode === ApiStatusCodeVo.ExternalRequestEndError ||
    resultCode === ApiStatusCodeVo.ExternalUnknownError
  ) {
    return {
      title: t('api_reward_redeem_use_fail'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.PointAge) {
    // 포인트 쿠폰이 연령 정보에 의해 실패한 경우임
    // 이때는 API 요청할 때 confirmed를 true로 보내야 정상적으로 등록됨
    return {
      title: t('more_coupon_register_button_popup'),
      description: t('more_coupon_register_age_limit_popup', {
        values: {
          value: title,
          rating: getAgeGradeText(ageGrade),
        },
      }),
      activeButton: t('common_confirm_button'),
      secondButton: t('common_cancel_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.ExternalExceedChargeLimit) {
    return {
      title: t('more_coupon_register_limit_exceeded_popup'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.ExternalExceedCashLimit) {
    return {
      title: t('more_coupon_register_cash_exceeded_popup'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.ExternalAbnormalUser) {
    return {
      title: t('more_coupon_register_invalid_user_popup'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.ExternalExceedMinorChargeLimit) {
    return {
      title: t('more_coupon_register_limit_exceeded_minor_popup'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.ExternalMismatchBrand) {
    return {
      title: t('more_coupon_register_Invalid_coupon_popup'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.ExternalCanceledCoupon) {
    return {
      title: t('more_coupon_register_refund_coupon_popup'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.ExternalMismatchAPIVersion) {
    return {
      title: t('more_coupon_register_api_inconsistency_popup'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.ExternalNotUsedCoupon) {
    return {
      title: t('more_coupon_register_not_used_popup'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.ExternalIrrevocableCoupon) {
    return {
      title: t('more_coupon_register_cancellation_is_not_possible_popup'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.ExternalCouponCancelFailed) {
    return {
      title: t('more_coupon_register_cancellation_fail_popup'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.RedeemInvalidTarget) {
    return {
      title: t('api_reward_redeem_invalid_target'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.RedeemFailGiveCash) {
    return {
      title: t('more_coupon_register_fail_popup'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.RedeemInvalidSeries) {
    return {
      title: t('more_coupon_register_not_eligible_contents_popup'),
      secondButton: t('common_confirm_button'),
    };
  } else if (
    resultCode === ApiStatusCodeVo.ItemAccessRestrictionCountryDenied
  ) {
    return {
      title: t('api_content_access_denied_country'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.RedeemDuplicatedDeviceId) {
    return {
      title: t('more_coupon_register_limited_device_popup'),
      secondButton: t('common_confirm_button'),
    };
  } else if (resultCode === ApiStatusCodeVo.ErrorShowServerMsg) {
    return {
      title,
      secondButton: t('common_confirm_button'),
    };
  } else {
    return {
      title: t('viewer_video_error_unknown'),
      secondButton: t('common_confirm_button'),
    };
  }
}
